interface AnuncioComDataDeCriacao {
  createdAt: string;
}

export function ordenarAnunciosPorCriacao<T extends AnuncioComDataDeCriacao>(
  anuncios: T[],
): T[] {
  return [...anuncios].sort(
    (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );
}
